import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";
import {
  VOID_CONFIRM_MESSAGE,
  VOID_STATUS_FIELD,
} from "../utils/voidTransactionConfig";

export const screen_118_sales_return_voucher: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "124",
    },
    title: "Sales return voucher",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "sales_return_no",
            Name: "sales_return_summary",
            BindValue: "grid_sales_return_summary",
            SummeryActions: [
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Api: "sales_return_view",
                },
                tooltip: "View Report",
              },
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/sales_ret_add/<id>",
                },
                ActionType: "View",
                ScreenId: "124",
                tooltip: "View",
              },
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/sales_ret_add/<id>",
                },
                ActionType: ActionType.EDIT,
                ScreenId: "124",
                tooltip: "Edit",
                visibleForDraftOnly: true,
                hiddenWhenVoid: true,
              },
                            {
                ActionType: ActionType.VOID,
                permissionKey: "Void",
                confirmMessage: VOID_CONFIRM_MESSAGE,
                requireVoidReason: true,
                hiddenWhenVoid: true,
                visibleWhenNotDraft: true,
                voidReasonLabel: "Void Reason",
                tooltip: "Void",
                Action: {
                  Module: "sales_ret_add",
                  TransactionNoField: "sales_return_no",
                },
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "sales_return_voucher",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "sales_return_summary",
              TableName: "sales_return",
              DisplayName: "sales_return_summary",
              Query:
                "SELECT sr.id, sr.sales_return_date, sr.sales_return_no, sr.customer_name, sr.invoice_id, COALESCE(sr.is_draft, 0) AS is_draft, CASE WHEN COALESCE(sr.is_draft, 0) = 1 THEN 'Draft' ELSE '' END AS draft_status, COALESCE(si.invoice_no, srd.invoice_no) AS invoice_no, sr.customer_refno, users.username, COALESCE(NULLIF(sr.returned_amount, 0), COALESCE(sr.return_spare_net, 0) + COALESCE(sr.return_labour_net, 0) + COALESCE(sr.return_misc_net, 0), COALESCE(sp_agg.line_net, 0) + COALESCE(lb_agg.line_net, 0) + COALESCE(mc_agg.line_net, 0), 0) AS returned_amount, COALESCE(NULLIF(sr.return_spare_net, 0), sp_agg.line_net, 0) AS return_spare_net, COALESCE(NULLIF(sr.return_labour_net, 0), lb_agg.line_net, 0) AS return_labour_net, COALESCE(NULLIF(sr.return_misc_net, 0), mc_agg.line_net, 0) AS return_misc_net, (COALESCE(sp_agg.line_cnt, 0) + COALESCE(lb_agg.line_cnt, 0) + COALESCE(mc_agg.line_cnt, 0)) AS line_count, sr.is_void, CASE WHEN COALESCE(sr.is_void, 0) = 1 THEN 'Void' ELSE '' END AS status FROM sales_return sr LEFT JOIN LATERAL (SELECT invoice_no FROM sales_return_details WHERE parent_id = sr.id AND soft_delete = 0 ORDER BY created_at DESC NULLS LAST LIMIT 1) srd ON TRUE LEFT JOIN service_invoice si ON si.id = sr.invoice_id LEFT JOIN users ON users.id = sr.created_by LEFT JOIN LATERAL (SELECT COUNT(*) FILTER (WHERE COALESCE(return_qty, 0) > 0) AS line_cnt, COALESCE(SUM(return_net_amt), 0) AS line_net FROM sales_return_spareparts WHERE parent_id = sr.id AND soft_delete = 0) sp_agg ON TRUE LEFT JOIN LATERAL (SELECT COUNT(*) FILTER (WHERE COALESCE(return_qty, 0) > 0) AS line_cnt, COALESCE(SUM(return_net_amt), 0) AS line_net FROM sales_return_labour WHERE parent_id = sr.id AND soft_delete = 0) lb_agg ON TRUE LEFT JOIN LATERAL (SELECT COUNT(*) FILTER (WHERE COALESCE(return_qty, 0) > 0) AS line_cnt, COALESCE(SUM(return_net_amt), 0) AS line_net FROM sales_return_miscellaneous WHERE parent_id = sr.id AND soft_delete = 0) mc_agg ON TRUE WHERE sr.soft_delete = 0 ORDER BY sr.sales_return_date DESC, sr.sales_return_no DESC",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "txt_id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                VOID_STATUS_FIELD,
                {
                  IncludeLabel: true,
                  Label: "Return No.",
                  BindValue: "txt_sale_ord_no",
                  Json_Attribute: "sales_return_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Return date",
                  BindValue: "txt_returndate",
                  Json_Attribute: "sales_return_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Draft",
                  BindValue: "txt_draft_status",
                  Json_Attribute: "draft_status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "txt_is_draft",
                  Json_Attribute: "is_draft",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Invoice No.",
                  BindValue: "txt_invoice_no",
                  Json_Attribute: "invoice_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer name",
                  BindValue: "name",
                  Json_Attribute: "customer_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Ref No.",
                  BindValue: "txt_customer_refno",
                  Json_Attribute: "customer_refno",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Return amount",
                  BindValue: "txt_net_amt",
                  Json_Attribute: "returned_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Spare return",
                  BindValue: "txt_return_spare_net",
                  Json_Attribute: "return_spare_net",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Labour return",
                  BindValue: "txt_return_labour_net",
                  Json_Attribute: "return_labour_net",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Misc return",
                  BindValue: "txt_return_misc_net",
                  Json_Attribute: "return_misc_net",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Return lines",
                  BindValue: "txt_line_count",
                  Json_Attribute: "line_count",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "username",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
